(function () {
	'use strict';

	angular.module('app.setup')
		.service('metricsService', metricsService);

	metricsService.$inject = ['$http', 'URLS', 'leanFilterService'];

	function metricsService($http, URLS, leanFilterService) {
		var service = {
			getMetrics: getMetrics,
			cloneMetric: cloneMetric,
			getMetricsInfo: getMetricsInfo,
			cloneValueSteamMetrics: cloneValueSteamMetrics
		};

		return service;

		function getMetrics(resolutionType, siteId) {
			var pageUrl = String.format(URLS.viewMetrics, siteId || globalConfig.factory.id);
			pageUrl = addFilterQueryParams(pageUrl, resolutionType);
			return $http.get(URLS.host + pageUrl)
				.then(getMetricsComplete)
				.catch(getMetricsFailed);

			function getMetricsComplete(response) {
				return response.data;
			}

			function getMetricsFailed(error) {
				return [];
			}

		}

		function getMetricsInfo(siteIds, metricName, crossSiteName, isCrossSite, extraParams) {
			var pageUrl = String.format(URLS.metricsInfo, siteIds);
			var queryParams = {
				metricName: metricName,
				crossSiteName: crossSiteName,
				isCrossSite: isCrossSite
			};
			pageUrl += '?' + jQuery.param(queryParams);
			if (extraParams) {
				pageUrl += '&' + extraParams;
			}
			
			return $http.get(URLS.host + pageUrl)
				.then(getMetricsComplete)
				.catch(getMetricsFailed);

			function getMetricsComplete(response) {
				return response.data;
			}

			function getMetricsFailed(error) {
				return [];
			}

		}
		
		function cloneMetric(siteId, metricId, userId) {
			var pageUrl = String.format(URLS.cloneMetric, siteId, metricId, userId);
			return $http.post(URLS.host + pageUrl)
				.then(cloneMetricSuccess)
				.catch(cloneMetricFailure);

			function cloneMetricSuccess(response) {
				return response.data;
			}

			function cloneMetricFailure(error) {
				return [];
			}
		}

		function cloneValueSteamMetrics(siteId, body) {
			var pageUrl = String.format(URLS.cloneValueStreamMetrics, siteId);
			return $http.post(URLS.host + pageUrl, body)
				.then(cloneMetricSuccess)
				.catch(cloneMetricFailure);

			function cloneMetricSuccess(response) {
				return response.data;
			}

			function cloneMetricFailure(error) {
				return [];
			}
		}

		function addFilterQueryParams(url, resolutionType) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				if(filterQueryParam[i].key === 'activated') {
					if(filterQueryParam[i].value === 'inactive') {
						filterQueryParam[i].value = '0';
					} else {
						filterQueryParam[i].value = '1';
					}
				}
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			if (typeof resolutionType !== 'undefined') {
				qParams = appendQueryParam(qParams, 'resolutionType', resolutionType);
			}
			return parts[0] + qParams;
		}
	}

	
})();
